import { gidToId, pwCache, queryString } from './helpers'

export const urlWithParams = (path: string, params: any, trim: boolean = false) => {
  const qs = queryString(params, trim)
  const sep = qs ? '?' : ''
  return `${path}${sep}${qs}`
}

export const rootUrl = '/'

export const dashboardUrl = (params: any = {}) => urlWithParams('/dashboard', params)

export const dashboardPaymentsUrl = (params: any = {}) =>
  urlWithParams('/dashboard/payments/', params)
export const dashboardFulfillmentsUrl = (params: any = {}) =>
  urlWithParams('/dashboard/fulfillments/', params)

export const newsUrl = (params?: any) => urlWithParams(`/dashboard/news`, params)

export const plansUrl = '/plans'
export const planUrl = (gidOrId: any) => `/plans/${gidToId(gidOrId)}`
export const newPlanUrl = `/plans/new`
export const planProductsUrl = (gidOrId: string, params: any = {}) =>
  urlWithParams(`/plans/${gidToId(gidOrId)}/products`, params)

export const subscriptionsUrl = (params?: any) =>
  urlWithParams('/subscriptions', params ?? pwCache.subscriptionFilter, true)

export const subscriptionUrl = (gidOrId: any) => `/subscriptions/${gidToId(gidOrId)}`
export const subscriptionCreateUrl = '/subscriptions/create'

export const settingsUrl = () => '/settings'
export const customerPortalSettingsUrl = () => '/customer-portal-settings'
export const pricingPlansUrl = () => '/settings/pricing-plans'
export const widgetTranslationsUrl = () => '/settings/translations'
export const customerPortalTranslationsUrl = () => '/customer-portal-settings/translations'
export const callbackDeliveriesUrl = (params: any = {}) =>
  urlWithParams('/settings/webhook-deliveries', params)
export const emailSettingsUrl = (mailType: string) => `/customer-portal-settings/emails/${mailType}`
export const legacyPlanSelectorInstallUrl = (params: any = {}) =>
  urlWithParams('/settings/legacy-plan-selector', params)

export const workflowsUrl = '/workflows'
export const workflowCreateUrl = (params: any = {}) => urlWithParams('/workflows/create', params)
export const workflowUrl = (id: number, params: any = {}) =>
  urlWithParams(`/workflows/${id}`, params)
export const workflowLogsUrl = (params: any = {}) => urlWithParams('/workflows/logs', params)

export const subscriptionFlowsCreateUrl = (params: any = {}) =>
  urlWithParams('/workflows/subscription-flows/create', params)
export const subscriptionFlowsUrl = (id: number) => `/workflows/subscription-flows/${id}`

export const partnersUrl = '/partners'
